import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const archiveMediasToQualify = async ({ mediaIds }) => {
  const body = {
    medias: mediaIds,
  };

  const response = await axiosInstance.patch('/medias/archive/', body);
  return response.data;
};

export const useArchiveMediasToQualify = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...options,
    mutationFn: archiveMediasToQualify,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['medias'] });

      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
  });

  return {
    archiveMediasToQualify: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
